import { useAuth0 } from "@auth0/auth0-react";
import { apiClient } from "../services/apiClient";
import API_PATHS from "../api/apiPaths";

export const useAuthLogout = () => {
  const { logout } = useAuth0();
  const appLogout = async () => {
    try {
      await apiClient.post(API_PATHS.AUDIT_LOGGING.AUDIT_LOGGING);
    } catch (error) {
      console.error("Audit logging failed", error);
    } finally {
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    }
  };

  return { appLogout };
};
